import React, { JSX } from "react";
import { t } from "utilities/localization/t";
import { ProviderRecord } from "models/view-models/providers/provider-record";
import { Card } from "components/card/card";
import {
    Paragraph,
    ParagraphSize,
    ParagraphStyle,
} from "components/typography/paragraph/paragraph";
import { FormFieldReadonly } from "components/form/form-field-readonly/form-field-readonly";
import { Badge, BadgeStyle } from "components/badges/badge/badge";
import "./provider-status-card.scss";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

interface ProviderStatusCardProps {
    provider?: ProviderRecord;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const CSS_CLASS_NAME = "provider-status-card";

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const ProviderStatusCard: React.FC<ProviderStatusCardProps> = ({ provider }): JSX.Element => {
    return (
        <Card cssClassName={`${CSS_CLASS_NAME} flex flex-col gap-5 basis-3/5`}>
            <Paragraph size={ParagraphSize.Large} style={ParagraphStyle.Bold}>
                {t("organizationStatus")}{" "}
                <Badge
                    style={provider?.isActive ? BadgeStyle.Success : BadgeStyle.Warning}
                    text={provider?.isActive ? t("active") : t("inactive")}
                />
            </Paragraph>
            <Paragraph>
                {t(
                    "theStatusAsAnActiveAenProviderIsContingentUponTheOrganizationsComplianceWithTheAenContractTimelyPaymentsAndFavorableCustomerEvaluations"
                )}
            </Paragraph>
            <div className={`${CSS_CLASS_NAME}__columns__fields mt-auto`}>
                <FormFieldReadonly
                    label={t("organization").toLocaleUpperCase()}
                    labelStyle={ParagraphStyle.Light}>
                    <Paragraph size={ParagraphSize.Small} style={ParagraphStyle.Bold}>
                        {provider?.name}
                    </Paragraph>
                </FormFieldReadonly>
                <FormFieldReadonly label={t("yourRole")} labelStyle={ParagraphStyle.Light}>
                    <Paragraph size={ParagraphSize.Small} style={ParagraphStyle.Bold}>
                        {t("enProviderAdmin")}
                    </Paragraph>
                </FormFieldReadonly>
            </div>
        </Card>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { ProviderStatusCard };

// #endregion Exports
